export const paths = {
  root: '/',
  error: {
    page403: `/403`,
    page404: `/404`,
    page500: `/500`,
  },
  auth: {
    singIn: `/seller/auth/sign-in`,
    signUp: `/seller/auth/sign-up`,
  },
  pages: {
    about: '/about-us',
    contact: '/contact-us',
    privacyPolicy: '/privacy-policy',
    termsOfService: '/terms-of-service',
    information: '/information',
    services: {
      root: '/services',
      promotion: {
        root: '/services/promotion',
        services: {
          seoOptimization: '/services/promotion/seo-optimization',
          descriptionGeneration: '/services/promotion/description-generation',
        },
      },
      analytics: {
        root: '/services/analytics',
        services: {
          nicheAnalysis: '/services/analytics/niche-analysis',
          returnsAnalysis: '/services/analytics/returns-analysis',
        },
      },
      productsAndPrices: {
        root: '/services/products-and-prices',
        services: {
          autoPricing: '/services/promotion/auto-pricing',
        },
      },
      orders: {
        root: '/services/orders',
        services: {
          stockForecast: '/services/orders/stock-forecast',
          orderAssembly: '/services/orders/order-assembly',
          autoReviews: '/services/orders/auto-reviews',
        },
      },
    },
    tariffs: '/tariffs',
    faq: '/faq',
  },
};

export const pathsByTechnicalName = {
  return_rate: '',
  niche_and_trend_analyses: '',
  order_assembly: '',
  review_ai_answer: '',
  stock_forecasting: '',
  auto_discount: '',
  seo_keyword: paths.pages.services.promotion.services.seoOptimization,
  description_generator: paths.pages.services.promotion.services.descriptionGeneration,
} as any;
